"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Dialog_component_exports = {};
__export(Dialog_component_exports, {
  Dialog: () => Dialog,
  useDialog: () => useDialog,
  useDialogContext: () => useDialogContext
});
module.exports = __toCommonJS(Dialog_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_react2 = require("@floating-ui/react");
var import_DialogContent = require("./DialogContent.component");
var import_clsx = __toESM(require("clsx"));
function useDialog({
  initialOpen = false,
  open: controlledOpen,
  onOpenChange: setControlledOpen,
  closeOnEscape,
  closeOnOverlayClick,
  role
} = {}) {
  const [uncontrolledOpen, setUncontrolledOpen] = (0, import_react.useState)(initialOpen);
  const [labelId, setLabelId] = (0, import_react.useState)();
  const [descriptionId, setDescriptionId] = (0, import_react.useState)();
  const open = controlledOpen != null ? controlledOpen : uncontrolledOpen;
  const setOpen = setControlledOpen != null ? setControlledOpen : setUncontrolledOpen;
  const data = (0, import_react2.useFloating)({
    open,
    onOpenChange: setOpen
  });
  const context = data.context;
  const click = (0, import_react2.useClick)(context, {
    enabled: controlledOpen == null
  });
  const dismiss = (0, import_react2.useDismiss)(context, {
    escapeKey: closeOnEscape || false,
    outsidePress: closeOnOverlayClick || false,
    outsidePressEvent: "mousedown"
  });
  const roleDialog = (0, import_react2.useRole)(context, {
    role
  });
  const interactions = (0, import_react2.useInteractions)([click, dismiss, roleDialog]);
  return (0, import_react.useMemo)(
    () => __spreadProps(__spreadValues(__spreadValues({
      open,
      setOpen
    }, interactions), data), {
      labelId,
      descriptionId,
      setLabelId,
      setDescriptionId
    }),
    [open, setOpen, interactions, data, labelId, descriptionId]
  );
}
const DialogContext = (0, import_react.createContext)(null);
const useDialogContext = () => {
  const context = (0, import_react.useContext)(DialogContext);
  if (context == null) {
    throw new Error("Dialog components must be wrapped in <Dialog />");
  }
  return context;
};
const Dialog = (_a) => {
  var _b = _a, {
    children,
    autoFocus,
    triggerId
  } = _b, options = __objRest(_b, [
    "children",
    "autoFocus",
    "triggerId"
  ]);
  const contentRef = (0, import_react.useRef)(null);
  const isFirstRender = (0, import_react.useRef)(true);
  const dialog = useDialog(options);
  const baseStyle = (0, import_clsx.default)([
    "bg-raised rounded-[10px]",
    "m-[20px] max-h-[70vh] p-6 items-start flex flex-col overflow-y-auto w-10/12"
  ]);
  (0, import_react.useEffect)(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (autoFocus) autoFocus.current.focus();
  }, [contentRef.current]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogContext.Provider, { value: dialog, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_DialogContent.DialogContent,
    __spreadProps(__spreadValues({
      "data-testid": "dialog-content-wrapper",
      id: options.id,
      className: baseStyle,
      ref: contentRef
    }, options), {
      "aria-modal": "true",
      triggerId,
      children
    })
  ) });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Dialog,
  useDialog,
  useDialogContext
});
//# sourceMappingURL=Dialog.component.js.map